import axios from "axios";
import { getBaseUrl } from "../../utils/common";

// import getBaseUrl from "./base-url";

export default axios.create({
    baseURL: `${getBaseUrl()}/api/V1`,
    //withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});
